module.exports = __webpack_public_path__ + "static/fire.173e98fe.svg";